






































































import FleetManagerTreeDialog from "@/components/fleet/FleetManagerTreeDialog.vue";
import MyDamageDetailSideCard from "@/components/report/user/MyDamageDetailSideCard.vue";
import Notifications from "@/components/thg/Notifications.vue";
import ErrorCard from "@/components/utility/ErrorCard.vue";
import MHeader, { IAction } from "@/components/utility/mmmint/MHeader.vue";
import PaginatedTable from "@/components/utility/v2/PaginatedTable.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { IBreadcrumb } from "@/lib/interfaces/utility/breadcrumb-interface";
import { ITableWrapperHeader } from "@/lib/types/tableWrapper";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { IReport } from "@/models/report.entity";
import { DamageFleetModule } from "@/store/modules/fleet/damage-fleet.store";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { ReportModule } from "@/store/modules/report.store";
import { PredefinedFilterType } from "@/views/event/filter/event.filter";
import { debounce } from "debounce";
import { Component, Vue } from "vue-property-decorator";
import { REPORT_COLOR_BY_STATUS } from "../user/MyDamageView.vue";

@Component({
  components: {
    LayoutReportWithBanner,
    Notifications,
    MyDamageDetailSideCard,
    PaginatedTable,
    FleetManagerTreeDialog,
    ErrorCard,
    MHeader
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class FleetDamageView extends Vue {
  readonly store = DamageFleetModule;

  CurrencyEnum = CurrencyEnum;
  formatCurrency = formatCurrency;

  isDialog = false;

  loading = false;
  isError = false;
  selectedId: string | null = null;
  updateTableKey = "";

  get breadCrumbs(): IBreadcrumb[] {
    const breadCrumbs: IBreadcrumb[] = [];

    breadCrumbs.push({
      text: $t("nav.FleetTableView.description"),
      disabled: false,
      exact: true,
      to: {
        name: "FleetAnalyticsView",
        params: {}
      }
    });

    breadCrumbs.push({
      text: $t("common.nouns.report"),
      disabled: false,
      exact: false,
      to: {
        name: "FleetDamageView",
        params: {}
      }
    });

    return breadCrumbs;
  }

  get chips(): IAction[] {
    return [
      {
        text: `${DamageFleetModule.totalItems} ${$t("common.nouns.report")}`,
        key: "fahrzeuge",
        icon: "mdi-car-wrench"
      }
    ];
  }

  get actions(): IAction[] {
    return [
      {
        text: $t("views.report.fleet.FleetAnalyticsView.selectionDialog.openFleetTree").toString(),
        key: "fleet",
        exec: () => ((this.$refs.dialog as unknown) as IDialog)?.open(),
        disabled: this.selectedFleetIds.length <= 1
      }
    ].filter(a => !a.disabled);
  }

  get predefinedFilter(): PredefinedFilterType[] {
    return [];
  }

  get partnerId() {
    return ReportModule.partner.id;
  }

  get selectedFleetIds() {
    return FleetManagerModule.selectedFleetIds;
  }

  get fleetId() {
    return FleetManagerModule.selectedFleetId;
  }

  get currentReport() {
    return DamageFleetModule.currentReport;
  }

  get colorByStatus() {
    return REPORT_COLOR_BY_STATUS;
  }

  get headers(): ITableWrapperHeader[] {
    return [
      {
        text: $t("objects.timestamp.created"),
        align: "start",
        width: 120,
        value: "timestamp.created",
        mapping: (item: IReport) => (!item ? "" : simpleDoubleDigitDate(item.timestamp.created))
      },
      {
        text: $t("common.nouns.company"),
        align: "start",
        width: 200,
        value: "companyName"
      },
      {
        text: $t("objects.report.numberplate"),
        align: "start",
        width: 120,
        value: "numberplate"
      },
      {
        text: $t("objects.report.costCenter"),
        align: "start",
        width: 120,
        value: "costCenter"
      },
      {
        text: $t("objects.report.leasing.claimNumber"),
        align: "start",
        width: 150,
        value: "claimNumber"
      },
      {
        text: $t("report.accidentDetails.date"),
        align: "start",
        width: 120,
        value: "accidentDetails.date",
        mapping: (item: IReport) =>
          !item?.accidentDetails?.date ? "" : simpleDoubleDigitDate(item.accidentDetails.date)
      },
      {
        text: $t("common.nouns.weekday"),
        align: "start",
        width: 120,
        value: "accidentDetails.weekday",
        mapping: (item: IReport) =>
          !item?.accidentDetails?.date
            ? ""
            : new Date(item.accidentDetails.date).toLocaleDateString("de-DE", { weekday: "long" })
      },
      {
        text: $t("objects.report.status"),
        align: "start",
        width: 180,
        value: "status",
        mapping: (item: IReport) => (item?.status ? item.status : $t(`enums.ProgressStatusEnum.${item.progressStatus}`))
      },
      {
        text: $t("objects.report.coverageType"),
        align: "start",
        value: "coverageType",
        width: 120,
        mapping: (item: IReport) => (!item?.coverageType ? "" : $t(`enums.CoverageTypeEnum.${item.coverageType}`))
      },
      {
        text: $t("common.nouns.fleet"),
        align: "start",
        width: 200,
        value: "fleet.title"
      },
      {
        text: $t("objects.report.repair.status"),
        align: "start",
        width: 140,
        value: "repair.status",
        mapping: (item: IReport) => (!item?.repair?.status ? "" : $t(`enums.RepairStatusEnum.${item.repair.status}`))
      },
      {
        text: $t("components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.parties.workshop"),
        align: "start",
        width: 200,
        value: "workShopCompany.company"
      },
      {
        text: $t("report.user.MyDamageDetail.customerName"),
        align: "start",
        width: 200,
        value: "customerName"
      },
      {
        text: $t("objects.report.tripType"),
        align: "start",
        value: "tripType",
        width: 120,
        mapping: (item: IReport) => (!item?.status ? "" : $t(`enums.TripTypeEnum.${item.tripType}`))
      },
      {
        text: $t("objects.report.damageType"),
        align: "start",
        value: "damageType",
        mapping: (item: IReport) => (!item?.damageType ? "" : $t(`enums.DamageTypeEnum.${item.damageType}`))
      },
      {
        text: $t("components.partner.PartnerReportDetailInfoCard.damageLocator.title").toString(),
        align: "start",
        value: "damage",
        width: 150,
        mapping: (item: IReport) =>
          (item?.damage ?? [])
            .map(damage =>
              $t(`components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.damages.${damage}`)
            )
            .join(", ")
      },
      {
        text: $t("objects.report.invoiceInboundAggregation"),
        align: "end",
        value: "invoiceInboundAggregation.totals",
        width: 220,
        mapping: (item: IReport) =>
          (item?.invoiceInboundAggregation?.totals ?? [])
            ?.map(total => formatCurrency(total.subtotal, total.currency as CurrencyEnum))
            .join(", ") || "-"
      },
      {
        text: $t("objects.report.invoiceSelfContributionAggregation"),
        align: "end",
        value: "invoiceSelfContributionAggregation.totals",
        width: 220,
        mapping: (item: IReport) =>
          (item?.invoiceSelfContributionAggregation?.totals ?? [])
            ?.map(total => formatCurrency(total.subtotal, total.currency as CurrencyEnum))
            .join(", ") || "-"
      },
      { text: "", value: "controls", align: "end", sortable: false }
    ];
  }

  get fleets() {
    return FleetManagerModule.fleets;
  }

  mounted() {
    const vehicleId = this.$route.query["vehicleId"] as string;

    if (vehicleId) {
      this.store.setFilters([new PageFilterElement({ key: "vehicleId", operation: "$eq", value: vehicleId })]);
    }
  }

  async openDetail(item: IReport) {
    this.$log.debug(item);

    if (!this.fleetId) {
      return;
    }

    this.loading = true;
    this.selectedId = null;

    try {
      const report = await DamageFleetModule.getOne({
        partnerId: this.partnerId,
        fleetId: this.fleetId,
        id: item._id
      });
      this.selectedId = report._id;
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }

  debounceUpdateTable = debounce(this.updateTable, 200);
  updateTable() {
    // We filter using base query. The data access layer has to be cleared of all "old" results.
    this.store.reset();
    this.updateTableKey = FleetManagerModule.selectedFleetIds.join("_");
  }
}
